/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import { bool, string, func, shape } from "prop-types";
import { actions as statusActions } from "reducers/status";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { selectors as sessionSelectors } from "reducers/session";
import Notification from "pages/_components/Notification";
import Step2Content from "pages/login/_components/Step2Content";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import withExchangeToken from "pages/_components/withExchangeToken";
import * as i18n from "util/i18n";
import { push } from "react-router-redux/actions";
import I18n from "pages/_components/I18n";
import GridLayoutExternal from "pages/_layouts/GridLayoutExternal";
import Logo from "pages/login/_components/Logo";
import Container from "pages/_components/Container";
import { Col } from "react-bootstrap";
import { isIOS } from "react-device-detect";

import { getPostLoginHomePath } from "util/v3UxConfig";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

class LoginStep2 extends Component {
    componentDidMount() {
        const { dispatch, activeEnvironment, username, uxDashboardImprovements, ...rest } = this.props;
        if (activeEnvironment) {
            dispatch(push(getPostLoginHomePath(uxDashboardImprovements)));
            return;
        }
        if (!username) {
            dispatch(push("/"));
            return;
        }

        dispatch(statusActions.saveLastHref(rest.location));

        if (isIOS) {
            window.scrollTo(0, 1);
        }
    }

    onHeaderClose = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
    };

    renderTitleMobile = () => (
        <div className="w-min-content">
            <Logo className="svg-image logo logo-mobile-size" logoColor />
        </div>
    );

    render() {
        const { isDesktop, userFirstName, isInFlow, propsGrid } = this.props;

        if (!isDesktop) {
            return (
                <>
                    <Notification scopeToShow="loginStep2" />
                    {isInFlow && (
                        <>
                            <Container>
                                <Col xs="12">
                                    <Head
                                        replace={{
                                            USER_NAME:
                                                userFirstName && userFirstName.length > 1
                                                    ? userFirstName
                                                          .split(" ")
                                                          .map(
                                                              (x) =>
                                                                  x.charAt(0).toUpperCase() + x.slice(1).toLowerCase(),
                                                          )
                                                          .join(" ")
                                                    : "",
                                        }}
                                        onClose={this.onHeaderClose}
                                        accessibilityTextId="login.step2.header.a11y"
                                        headerClassName="login-background-color-white"
                                        fixed
                                        centerElement={this.renderTitleMobile}
                                        hideMobileMenu
                                    />
                                </Col>
                            </Container>
                            <div className="login-second-step">
                                <MainContainer className="login__layout main-container">
                                    <Container>
                                        <Col xs="12">
                                            <h4>
                                                <I18n
                                                    id="login.step2.header"
                                                    accessibilityTextId="login.step2.header.a11y"
                                                />
                                            </h4>
                                        </Col>
                                    </Container>
                                    <Step2Content isDesktop={isDesktop} />
                                </MainContainer>
                            </div>
                        </>
                    )}
                </>
            );
        }

        return (
            <GridLayoutExternal scopeToShow="loginStep2" isDesktop={isDesktop} {...propsGrid}>
                {isInFlow && (
                    <>
                        <Head
                            title="login.step2.header"
                            replace={{
                                USER_NAME:
                                    userFirstName && userFirstName.length > 1
                                        ? userFirstName
                                              .split(" ")
                                              .map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
                                              .join(" ")
                                        : "",
                            }}
                            onClose={this.onHeaderClose}
                            headerClassName="recover-pass-desktop login-header-desktop"
                            fixed
                            tag="h4"
                        />
                        <div className="login-second-step">
                            <MainContainer className={classNames("login__layout main-container", "container-fluid")}>
                                <Step2Content isDesktop={isDesktop} />
                            </MainContainer>
                        </div>
                    </>
                )}
            </GridLayoutExternal>
        );
    }
}

LoginStep2.propTypes = {
    isDesktop: bool.isRequired,
    userFirstName: string.isRequired,
    isInFlow: bool.isRequired,
    dispatch: func.isRequired,
    propsGrid: shape({}).isRequired,
    username: string.isRequired,
    activeEnvironment: shape({}).isRequired,
    uxDashboardImprovements: bool,
};

LoginStep2.defaultProps = {
    uxDashboardImprovements: false,
};

const mapStateToProps = (state) => ({
    userFirstName: loginSelectors.getUserFirstName(state) || i18n.get("login.defaultUserName"),
    isInFlow: loginSelectors.getIsInFlow(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    username: loginSelectors.getUsername(state),
    uxDashboardImprovements: isUxDashboardImprovementsEnabled(),
});

export default compose(withRouter, connect(mapStateToProps))(withExchangeToken(LoginStep2));
